import { Habit, ID, Insights, InsightSections } from '@griply/types';

import { hasScheduleInPeriod } from '../schedules';
import { sortItems } from '../sort-items';

export type GetInsightsHabitsOptions = {
  habits: Habit[];
  insightsSettings: Insights | null | undefined;
  habitSorting: ID[];
  periodStart: Date;
  periodEnd: Date;
};

export const getInsightsHabits = ({
  habits,
  insightsSettings,
  habitSorting,
  periodStart,
  periodEnd,
}: GetInsightsHabitsOptions): Habit[] => {
  const habitsSectionSettings =
    insightsSettings?.sections?.[InsightSections.Habits];
  const showHiddenItems = insightsSettings?.showHiddenItems ?? false;

  const filteredHabits = habits.filter(
    ({ id, completedAt, archivedAt, parentIds, schedules }) =>
      (showHiddenItems || !habitsSectionSettings?.hiddenItems?.includes(id)) &&
      !parentIds?.length &&
      !archivedAt &&
      !completedAt &&
      hasScheduleInPeriod(schedules, periodStart, periodEnd),
  );

  const sortedHabits = sortItems(filteredHabits, habitSorting, 'id');

  if (habitsSectionSettings?.order?.length) {
    return sortItems(
      sortedHabits,
      habitsSectionSettings.order,
      'id',
    ) as Habit[];
  }

  return sortedHabits as Habit[];
};
